import { css } from '@emotion/react'
import { memo } from 'react'
import { palette } from '../styles/colors'

const containerStyles = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
})

const descriptionStyles = css({
    color: palette.secondaryText,
    lineHeight: 1.5,
})

type CardProps = {
    title: string
    description: React.ReactNode
}

export const InformationCard = memo((props: CardProps) => {
    const { description, title } = props

    return (
        <div css={containerStyles}>
            <div className="card information-card">
                <div className="card-contents">
                    <h2
                        className="typography gutter-bottom"
                        data-testid="InformationCard__Title"
                    >
                        {title}
                    </h2>
                    <div
                        className="typography"
                        css={descriptionStyles}
                        data-testid="InformationCard__Description"
                    >
                        {description}
                    </div>
                </div>
            </div>
        </div>
    )
})
